module.exports = __webpack_public_path__ + "static/6-ab115fdbc10f203d8a3a19ce3f111689.png";